import { Dayjs } from 'dayjs';
import { t } from 'i18next';

export function getExternalService(enabled: boolean, lastSync?: Dayjs): { text: string | Date; color: string | null } {
  return {
    text: enabled ? (lastSync ? lastSync : t('common.notSynced').toLowerCase()) : t('common.deactivated').toLowerCase(),
    color: enabled ? (lastSync ? 'var(--color-success)' : 'var(--color-warning)') : null,
  };
}
